import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/ui/data-table";
import { notificationColumns } from "@/lib/columns";
import { Plus } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { axiosPrivate } from "@/api/axios";
import { toast } from "sonner";

function Notifications() {
  const { data, isLoading } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => {
      const res = await axiosPrivate.get("/notifications/");
      if (res.data.success) return res.data.data;
      toast.error(res.data.message || "Failed to fetch notifications");
      return [];
    },
    placeholderData: [],
  });

  return (
    <div className="space-y-5">
      <h1 className="text-4xl">Notifications</h1>
      <DataTable
        columns={notificationColumns}
        data={data}
        placeholder="Search Notifications"
        filterColumns={["title"]}
      />
    </div>
  );
}

export default Notifications;
